module.exports = __webpack_public_path__ + "img/th.683af0c3.svg";